import { RootState } from "../store";

export const rerenderSelector = (state: RootState) => state.rerender;
